





import Vue, { PropType } from "vue";
import { PPOrderStatus, PPOrderStatusMap } from "@/picking-portal/enums/PPOrderStatus";
import { ElementColors } from "@/common/theme/ElementColors";
import { PPClickAndCollectStatus, PPClickAndCollectStatusMap } from "../enums/PPClickAndCollectStatus";

export default Vue.extend({
  name: "PPOrderStatusChip",
  props: {
    status: {
      type: String as PropType<PPClickAndCollectStatus>,
      required: true,
    },
  },
  data() {
    return {
      Colors: ElementColors,
    };
  },
  methods: {
    getOrderStatusText(status: PPClickAndCollectStatus): string {
      return PPClickAndCollectStatusMap.get(status)?.text ?? "modules.packing-portal.order.status.unknown";
    },
    getOrderStatusColor(status: PPClickAndCollectStatus): string {
      return PPClickAndCollectStatusMap.get(status)?.color ?? ElementColors.Chip.Default;
    },
  },
});
